module.exports = __webpack_public_path__ + "static/media/Spanish_European_Javier BG-42.be5a4262.png";